import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { type MaybeRefOrGetter, unref } from 'vue';

export type ExpTypes = 'excursion' | 'tour' | 'ticket';
export type SortingTypes = '-review_rated_count' | '-review_rating' | 'random';
export type GuideType = 'guide' | 'team' | 'agency';

interface Params {
  city__slug?: MaybeRefOrGetter<string>;
  /**
   * Тип экспириенса (excursion,tour,ticket)
   */
  exp_types?: MaybeRefOrGetter<ExpTypes>;
  /**
   * Количество отзывов
   */
  page_size?: MaybeRefOrGetter<number>;
  /**
   * Минимальное количество туров
   */
  tours_count_min?: MaybeRefOrGetter<number>;
  /**
   * slug региона
   */
  region__slug?: MaybeRefOrGetter<string>;
  /**
   * slug страны
   */
  country__slug?: MaybeRefOrGetter<string>;
  /**
   * Вариант сортировки:
   * '-review_rated_count' - — по числу отзывов с оценками (по убыванию)
   * '-review_rating' - по рейтингу Вилсона на основе оценок отзывов (по убыванию)
   * 'random' - cлучайно
   */
  sorting?: MaybeRefOrGetter<SortingTypes>;
  /**
   * - фильтр по типу гидов (guide,team,agency)
   */
  guide_types?: MaybeRefOrGetter<GuideType>;
}

const normalizeParams = (params: Params) => {
  return {
    city__slug: params?.city__slug ? (unref(params?.city__slug) as string) : undefined,
    country__slug: params?.country__slug ? (unref(params?.country__slug) as string) : undefined,
    exp_types: params?.exp_types ? (unref(params?.exp_types) as ExpTypes) : undefined,
    page_size: params?.page_size ? (unref(params?.page_size) as number) : undefined,
    tours_count_min: params?.tours_count_min ? (unref(params?.tours_count_min) as number) : undefined,
    region__slug: params?.region__slug ? (unref(params?.region__slug) as string) : undefined,
    sorting: params?.sorting ? (unref(params?.sorting) as SortingTypes) : undefined,
    guide_types: params?.guide_types ? (unref(params?.guide_types) as GuideType) : undefined,
  };
};

export const useGuidesList = (params: Params) => {
  const { getGuides } = useExperienceApi();

  const { data: guidesList, isFetched } = useQuery({
    queryKey: ['guidesList', normalizeParams(params)],
    queryFn: () => {
      return getGuides({ query: { ...normalizeParams(params) } });
    },
    select: (response) => response.data,
    retry: false,
  });

  return { guidesList, isFetched };
};
